import Choices from 'choices.js';

/**
 * Init custom select element with choices.js
 * 
 * @param {string|HTMLSelectElement} el - HTML select element or select element CSS selector
 * @param {object} options - Optional settings
 * @param {boolean} [options.allowHTML=false] - @link https://github.com/Choices-js/Choices#allowhtml
 * @param {string} [options.itemSelectText] - @link https://github.com/Choices-js/Choices#itemselecttext
 * @param {string} [options.position] - @link https://github.com/Choices-js/Choices#position
 * 
 * @returns {Choices}
 */
export const initSelect = (el, options = {}) => {
  const _defaults = {
    allowHTML: false,
    itemSelectText: '',
    position: 'bottom',
  }
  const opts = { ..._defaults, ...options };
  const selectEl = (typeof el === 'string') ? document.querySelector(el) : el;

  return new Choices(selectEl, {
    allowHTML: opts.allowHTML,
    itemSelectText: opts.itemSelectText,
    position: opts.position,
  });
};
